module.exports = __webpack_public_path__ + "img/offers-add.b3ee0997.svg";